import React, { useState, useEffect } from "react";
import { Icon } from "@cdk-uip/react-icon";
import NoContent from "../NoContent";
import Loader from "../Loader";
import { LinearProgress } from "@cdk-uip/react-linear-progress";
let intervalCall;
let blobData;

const PDFViewer = props => {
  const [pageCount, setPageCount] = useState("");
  // const [blobData, setBlobData] = useState(null);
  const [noContent, setNoContent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toasterShow, setToasterShow] = useState(false);
  const [toasterMessage, setToasterMessage] = useState(false);

  let intervalCount = 0;
  useEffect(() => {
    // initialBlobCreation();
    getPageCount();
  }, []);

  // useEffect(() => {
  //   if (blobData) {
  //     getPageCount();
  //   }
  // }, [blobData]);

  const initialBlobCreation = async () => {
    let url = props.src;
    await fetch(url, {
      method: "GET"
    })
      .then(response => response.blob())
      .then(blob => {
        if (blob.type === "application/pdf") {
          blobData = blob;
          setIsLoading(false);
        } else {
          setNoContent(true);
          setIsLoading(false);
        }
      })
      .catch(err => {
        setNoContent(true);
        setIsLoading(false);
      });
  };

  const downloadPDF = async () => {
    setToasterShow(true);
    if (blobData) {
      const url = window.URL.createObjectURL(new Blob([blobData]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", props.name + ".pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setToasterShow(false);
      clearInterval(intervalCall);
    } else if (!intervalCall) {
      // initialBlobCreation();
      // setToasterMessage("Downloading...");
      intervalCall = setInterval(() => {
        downloadPDF();
        intervalCount++;
      }, 1500);
    } else if (intervalCount === 20) {
      clearInterval(intervalCall);
      intervalCall = null;
      setToasterShow(false);
      setToasterMessage("Failed to download!");
      hideToaster();
      // setButtonDisable(false);
    }
  };

  const hideToaster = () => {
    if (intervalCall) clearInterval(intervalCall);
    setTimeout(() => {
      setToasterMessage(false);
    }, 5000);
  };

  const getPageCount = async () => {
    await initialBlobCreation();
    if (blobData) {
      var reader = new FileReader();
      reader.readAsBinaryString(blobData);
      reader.onloadend = function() {
        var count = reader.result.match(/\/Type[\s]*\/Page[^s]/g).length;
        setPageCount(count);
      };
    }
  };

  return isLoading ? (
    <Loader />
  ) : noContent ? (
    <>
      <h2 style={{ marginBottom: "5px", paddingLeft: "16px" }}>
        {props.entName}
      </h2>
      <span className="dateSpan">DATE SENT - {props.date}</span>
      <NoContent />
    </>
  ) : (
    <>
      <h2 style={{ marginBottom: "5px", paddingLeft: "16px" }}>
        {props.entName}
      </h2>
      <span className="dateSpan">DATE SENT - {props.date}</span>
      {pageCount ? (
        <p className="dateSpan" style={{ marginTop: "7px" }}>
          Total Pages: {pageCount}
        </p>
      ) : (
        <div
          className="loading-demo"
          style={{
            height: "15px",
            position: "relative",
            bottom: "13px",
            width: "100%",
            marginTop: "20px"
          }}
        ></div>
      )}
      <div
        className="pdfWrapper"
        style={{ marginLeft: props.isMobile ? "0px" : "16px" }}
      >
        <iframe
          // height={props.isMobile ? "240" : "370"}
          height="240"
          className="videoDiv"
          src={props.src}
          frameborder="0"
        ></iframe>
        <div className="pdfOverlayClass">
          <a href={props.src} target="_blank">
            <Icon
              id="playpause"
              className="cdkicon-search"
              style={{
                fontSize: props.isMobile ? "100px" : "120px",
                height: props.isMobile ? "50%" : "35%"
              }}
            >
              cdkicon-search
            </Icon>
          </a>
        </div>
      </div>

      <div className="buttonsClassPdfViewer" style={{ textAlign: "center" }}>
        <a href={props.src} target="_blank">
          <button className="downloadButton">
            <Icon
              style={{ verticalAlign: "middle", paddingRight: "2px" }}
              className="cdkicon-search"
            >
              cdkicon-search
            </Icon>
            View PDF
          </button>
        </a>
        {toasterShow ? (
          <div
            style={{
              opacity: "0.7",
              color: "#151B25",
              fontFamily: "Roboto",
              fontSize: "16px",
              letterSpacing: "0",
              lineHeight: "24px",
              paddingLeft: "16px",
              marginTop: "5px",
              width: "15rem"
            }}
          >
            <span>Downloading...</span>
            <LinearProgress
              style={{ marginTop: "3%", width: "95%" }}
              indeterminate
            />
          </div>
        ) : (
          <button className="downloadButton" onClick={downloadPDF}>
            <Icon
              style={{ verticalAlign: "middle", paddingRight: "2px" }}
              className="cdkicon-file_download"
            >
              cdkicon-file_download
            </Icon>
            Download
          </button>
        )}
      </div>
      {toasterMessage ? (
        <div
          className="storeview-notification-type"
          id="storeview-notification"
        >
          <p>{toasterMessage}</p>
        </div>
      ) : null}
    </>
  );
};

export default PDFViewer;
